exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lar_form_row:last-child .form-group {\n  margin-bottom: 0;\n}\n.lar_form_row p, .lar_form_row span {\n  font-weight: normal;\n}\n\n.lar_form .custom-control-label {\n  line-height: 1.6rem;\n  margin-left: 1.5rem;\n}\n.lar_form .form-check {\n  padding-top: 5px;\n  line-height: 34.25px;\n}", ""]);

// exports
